import React from 'react';
import { MenuItem, SubMenu } from 'react-pro-sidebar';
import { Link } from 'react-router-dom';

type BaseMenuItemProps = {
  active: boolean;
  label: string;
  icon?: React.ReactNode;
};

type MenuItemProps = BaseMenuItemProps &
  (
    | { to: string; href?: never; children?: never }
    | { href: string; to?: never; children?: never }
    | { children: React.ReactNode; to?: never; href?: never }
  );

export const SidebarMenuItem = (props: MenuItemProps) => {
  const { active, children, href, label, to, ...rest } = props;
  const className = active ? 'active' : '';
  const component = to ? (
    <Link to={to} />
  ) : href ? (
    <a href={href} target="_blank" rel="noopener noreferrer" />
  ) : undefined;

  return (
    <>
      {children ? (
        <SubMenu className={className} title={label} label={label} {...rest}>
          {children}
        </SubMenu>
      ) : (
        <MenuItem className={className} component={component} {...rest}>
          {label}
        </MenuItem>
      )}
    </>
  );
};

type SubMenuItemProps = {
  active: boolean;
  label: string;
  to: string;
};

export const SidebarSubMenuItem = (props: SubMenuItemProps) => {
  const { active, label, to, ...rest } = props;

  return (
    <MenuItem className={active ? 'sub-active' : ''} component={<Link to={to} />} {...rest}>
      {label}
    </MenuItem>
  );
};
